import { z } from 'zod';

/**
 * Frontend sanity window for manually entered primary-range dates. The API
 * accepts any year, so this exists to reject the transient values MUI's range
 * field publishes per keystroke (e.g. year `0202` while typing `2025`). Kept
 * in line with the `DatePicker` molecule's default `minDate`/`maxDate`.
 */
const MANUAL_FILTER_DATE_MIN = '1900-01-01';
const MANUAL_FILTER_DATE_MAX = '2099-12-31';

const zodManualFilterDateSchema = z.iso.date();

/**
 * Checks that a manual primary-range entry is a real `YYYY-MM-DD` calendar
 * date inside the supported window. Rejects dayjs's literal `"Invalid Date"`
 * output and mid-typing years so they never reach the filter store or an API
 * payload (DNI-839). Bounds compare as strings, which is safe because the
 * schema guarantees a zero-padded ISO date.
 */
export function isValidManualFilterDate(value: unknown): value is string {
  return (
    typeof value === 'string' &&
    zodManualFilterDateSchema.safeParse(value).success &&
    value >= MANUAL_FILTER_DATE_MIN &&
    value <= MANUAL_FILTER_DATE_MAX
  );
}
